import {Component, EventEmitter, Input, Output} from '@angular/core';

export interface FilterButton {
  key?: string;
  value?: any;
  selected?: boolean;
}

@Component({
  selector: 'app-filter-buttons',
  templateUrl: './filter-buttons.component.html',
})
export class FilterButtonsComponent {

  @Input() filterTitle: string;

  @Input() pgtReturn = false;

  @Input() objKey = 'key';

  @Input()
  filters: FilterButton[] = [];

  @Input() inputClass: 'primary' | 'accent' | 'secondary' | 'green' = "primary";

  @Output()
  emitFilter = new EventEmitter<any>();

  toggleSelection(btn: any) {
    const modButtons: FilterButton[] = this.filters.map(bt => {
      // Check if the current button is the one being clicked
      if (bt.value === btn.value) {
        // If it is, set its selected state to true
        return {...bt, selected: true};
      } else {
        // Otherwise, deselect it
        return {...bt, selected: false};
      }
    });
    this.filters = modButtons;

    if (this.pgtReturn) {
      const arrayOfObjects: FilterButton[] = modButtons.filter(i => i.selected).map(btn => ({[this.objKey]: btn.value}))
      this.emitFilter.emit(arrayOfObjects[0]);
    } else {
      this.emitFilter.emit(modButtons);
    }
  }


}
